module.exports = __webpack_public_path__ + "img/merchant.b7e69d00.png";